export class AdditionalFeature {
  id: number = null;
  name: string = null;
  notes: string = null;
}
